export default {
  forest_product_cooperatives: {
    name: "Forest product cooperatives",
    description: "Formation of local cooperatives to market sustainable non-timber forest products.",
  },
  satellite_monitoring: {
    name: "Satellite monitoring",
    description: "Use satellite imagery to track land-use changes and support enforcement.",
  },
  firebreak_construction: {
    name: "Firebreak construction",
    description: "Create physical barriers to reduce wildfire spread.",
  },
  community_patrols: {
    name: "Community forest patrols",
    description: "Train local teams to monitor the area and report illegal logging.",
  },
  youth_engagement: {
    name: "Youth engagement programs",
    description: "Create opportunities for young people to join conservation activities.",
  },
  agroforestry_training: {
    name: "Sustainable agroforestry training",
    description: "Train local farmers in agroforestry and forest-conservation practices.",
  },
  reforestation: {
    name: "Reforestation campaigns",
    description: "Organize native-tree planting to restore degraded areas.",
  },
  water_protection: {
    name: "Water source protection",
    description: "Protect streams, springs, and riparian areas inside the project.",
  },
};
